<template>
	<QwoachDialogLayout class="invoice-details-root">

		<div>
			<p>Click the "confirm payment" button below to manually mark this payment as completed.</p>
			<p>Set paid date to
				<el-date-picker
					v-model="paidDateData"
					class="pointer no-select show-prefix-icon"
					type="date"
					style="width: 130px"
					:clearable="false"
					format="MMM dd, yyyy"
					placeholder="Pick a day"
					@change="onPaidDateChanged">
				</el-date-picker>
				<i class="fontello icon-down-dir text-muted"/>
			</p>
			<br/>

			<InvoiceDetails v-if="invoiceGroup && invoiceGroup.generalInvoice()" :invoice="invoiceGroup.generalInvoice()"/>


		</div>
		<template #footer>
			<div class="row dialog-footer mx-0" style="text-align: left">
				<el-button v-if="invoiceGroup" size="small" type="danger" plain @click="onWithdraw">Withdraw invoice</el-button>
				<el-button v-else size="small" plain type="success" @click="onCreateInvoice">
					Create invoice
				</el-button>
				<div class="layout-spacer"></div>
				<el-button size="small" @click="onCancel">Cancel</el-button>
				<el-button size="small" type="primary" @click="onYes">Confirm payment</el-button>
			</div>
		</template>
	</QwoachDialogLayout>
</template>

<script>

	import BillingItem from "@shared/Billing/BillingItem";
	import {InvoiceCommand} from "@shared/Invoice/InvoiceItem";

	import InvoiceDetails from "@/core/components/InvoiceDetails.vue"
	import InvoiceGroup from "@shared/Invoice/InvoiceGroup";
	import QwoachDialogLayout from "@/core/components/Dialogs/QwoachDialog/QwoachDialogLayout.vue";
	import QwoachDialog from "@/core/components/Dialogs/QwoachDialog/QwoachDialog.vue";


	export default {
		name: "InvoicedDialog",
		extends: QwoachDialog,
		components:{
			QwoachDialogLayout,
			InvoiceDetails
		},

		props: {
			billingItem: {type: BillingItem, default: () => new BillingItem()},
			invoiceGroup: InvoiceGroup,
			paidDate: {type: Date, default: () => new Date()}
		},
		data: () => ({
			paidDateData: new Date(),
			command: InvoiceCommand.CONFIRM,
			isLoading: true,
			invoiceIsLoading: true
		}),

		created(){
			if(this.invoiceGroup && this.invoiceGroup.paidDateTsIfAllSame()){
				this.paidDateData = new Date(this.invoiceGroup.paidDateTsIfAllSame())
			} else {
				this.paidDateData = this.paidDate
			}
		},

		methods: {

			onPaidDateChanged(){
				this.$analyticManager.trackEvent("Paid date changed", this.analyticsPropsMethod())
			},

			async onWithdraw(){
				let shouldDelete = await this.handleAsync(this.onBeforeDelete(), this.getDeleteLoadingText())
				if(!shouldDelete){
					return false
				}
				this.command = InvoiceCommand.WITHDRAW
				return this.onAction("actionWithdrawInvoice")
			},
			onYes() {
				if(!this.invoiceGroup){
					this.command = InvoiceCommand.CREATE_CONFIRMED
				}
				this.onAction("actionConfirmPayment")
			},
			createDataItem() {
				return {
					command: this.command,
					paidDate: this.paidDateData
				}
			},
			onCreateInvoice() {
				this.command = InvoiceCommand.CREATE
				this.onOk()
			},

			getItemName(){
				return "invoice"
			}

		},

		computed:{
			dialogTitle(){
				return "Already received this payment?"
			},

			deleteDialogConfirmActionTitle(){
				return "Withdraw"
			}
		}


	}
</script>


<style lang="scss">
.invoice-details-root{
}
</style>
